import {
  Box,
  CardMedia,
  Container,
  Hidden,
  Typography,
} from "@material-ui/core";
import { Style } from "@material-ui/icons";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import mainImage from "../../assets/img/welcomeScreen.jpg";
import { Generator } from "../../components/Generator";
import { Grid } from "../../components/Grid";
import { Heading } from "../../components/Heading";
import { loadAppData } from "../../components/appData.slice";
import { usePreventRefresh, useShowFooter, useTitle } from "../../hooks";

import styles from "./Welcome.module.scss";
import { form } from "./form";

export const Welcome = (): JSX.Element => {
  const dispatch = useDispatch();
  useTitle("Ayvens");
  useShowFooter();
  usePreventRefresh();
  useEffect(() => {
    dispatch(loadAppData());
  }, [dispatch]);

  return (
    <Container className={styles.container}>
      <Grid
        container
        className={styles.page}
        direction="row"
        spacingInnerLeft={{ xs: 5, sm: 10 }}
      >
        <Grid
          item
          className={styles.sidebar}
          spacingInnerTop={{ xs: 5, sm: 10 }}
          spacingInnerBottom={{ xs: 5, sm: 10 }}
          spacingInnerRight={{ xs: 5, sm: 6 }}
          xs={12}
          sm={6}
        >
          <Heading
            color="secondary"
            component="h1"
            variant="h2"
            spacingBottom={{ xs: 4, sm: 6 }}
          >
            Zgłoś szkodę bez zbędnych telefonów, drukowania i przesyłania
            dokumentów pocztą
          </Heading>
          <Typography paragraph>
            By sprawnie zgłosić szkodę przygotuj dowód rejestracyjny pojazdu,
            zdjęcia uszkodzeń pojazdu oraz prawo jazdy. Następnie odpowiedz na
            pytania, by przejść do formularza.
          </Typography>
          <Box mt={10}>
            <Generator
              form={form}
              render={(generatedForm) => (
                <Grid item xs={12} className={styles.WelcomeCheckboxesArea}>
                  {generatedForm}
                </Grid>
              )}
            />
          </Box>
        </Grid>
        <Hidden xsDown>
          <Grid item alignSelf="stretch" xs={6}>
            <CardMedia className={styles.image} image={mainImage}></CardMedia>
          </Grid>
        </Hidden>
      </Grid>
    </Container>
  );
};
